import React, {useContext, useEffect, useState} from "react";
import {useHistory} from 'react-router-dom'
import {ServerContext} from "../serverContext/ServerProvider";
import {Loader} from "../components/Loader";


export const Main = ({goods}) => {
    const history = useHistory()
    const {getAllOrders} = useContext(ServerContext)
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        let mounted = true

        async function wtf() {
            await getAllOrders(() => {
                if(mounted) {
                    setLoading(false)
                }
            })
            console.log(2)
        }

        console.log(1)
        wtf()

        return () => {mounted = false}
    }, [])

    return (
        <div className="main_container">
            {loading ? <Loader/> : (
                <div className='container-sm'>
                    {goods.map(good => (
                        <h1 key={good._id} className="link"
                            onClick={() => history.push('/admin' + good.link)}>{good.name}</h1>
                    ))}
                </div>
            )}
        </div>
    )
}